// Price alerts moved from the retired alert service to the market service.
// Endpoints live under `market/price-alert`, requests are snake_case (camelCase
// is also accepted) and responses are camelCase. There is no delete: an alert is
// cancelled with a PATCH and stays in the list as history.

export const PRICE_ALERT_CREATE = '/api/v1/market/price-alert';

/** Lists a page, or fetches a single alert when `id` is set — there is no GET by id. */
export const PRICE_ALERT_LIST = '/api/v1/market/price-alert/list';

/** Edit **or** cancel — `PATCH market/price-alert/{id}`. */
export const priceAlertUpdateUrl = (id: string) =>
  `/api/v1/market/price-alert/${id}`;

/** A REPEAT alert fires at most this many times before it becomes terminal. */
export const MAX_REPEAT_TRIGGERS = 3;

/** The market service answers 429 when a daily channel quota is exhausted. */
export const PRICE_ALERT_QUOTA_EXCEEDED_CODE = 429;

export const PRICE_ALERT_PAGE_SIZE = 20;
